import Konva from "konva"
import {
    Lifecycle,
    LifecyclePhase,
    LifecycleConnection,
} from "server/models"
import { OrderType, inferLiteral, StateType } from "client/utils"
import * as types from "./types"


export const setLifecyclePath = (path: readonly LifecyclePhase[]) => ({
    type: inferLiteral(types.LIFECYCLE_PATH),
    path,
})
export const setLifecycleBaseRoute = (baseRoute: string) => ({
    type: inferLiteral(types.LIFECYCLE_BASE_ROUTE),
    baseRoute,
})
export const setLifecycleOnSelectPhase = (onSelect: any) => ({
    type: inferLiteral(types.LIFECYCLE_ON_SELECT_PHASE),
    onSelect,
})


export const setLifecycleList = (lifecycleList: types.LifecycleList) => ({
    type: inferLiteral(types.LIFECYCLE_LIST),
    lifecycleList,
})
export const setLifecycleIds = (lifecycleIds: readonly number[]) => ({
    type: inferLiteral(types.LIFECYCLE_IDS),
    lifecycleIds,
})
export const setLifecycleView = (lifecycle: Lifecycle) => ({
    type: inferLiteral(types.LIFECYCLE_VIEW),
    lifecycle,
})
export const setLifecycleEdit = (lifecycle: Lifecycle) => ({
    type: inferLiteral(types.LIFECYCLE_EDIT),
    lifecycle,
})
export const setLifecycleReloadList = (value: boolean) => ({
    type: inferLiteral(types.LIFECYCLE_RELOAD_LIST),
    value,
})
export const setLifecycleReloadView = (value: boolean) => ({
    type: inferLiteral(types.LIFECYCLE_RELOAD_VIEW),
    value,
})
export const setLifecycleReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.LIFECYCLE_RELOAD_EDIT),
    value,
})


// lifecycle model

export const setLifecyclePhaseList = (phaseList: readonly LifecyclePhase[]) => ({
    type: inferLiteral(types.LIFECYCLE_PHASE_LIST),
    phaseList,
})
export const setLifecyclePhaseActive = (phase: LifecyclePhase) => ({
    type: inferLiteral(types.LIFECYCLE_PHASE_ACTIVE),
    phase,
})
export const setLifecyclePhaseConfirmDelete = (phase: LifecyclePhase) => ({
    type: inferLiteral(types.LIFECYCLE_PHASE_CONFIRM_DELETE),
    phase,
})
export const setLifecyclePhaseReloadActive = (value: boolean) => ({
    type: inferLiteral(types.LIFECYCLE_PHASE_RELOAD_ACTIVE),
    value,
})


export const setLifecycleConnectionList = (connectionList: readonly LifecycleConnection[]) => ({
    type: inferLiteral(types.LIFECYCLE_CONNECTION_LIST),
    connectionList,
})
export const setLifecycleConnectionActive = (connection: LifecycleConnection) => ({
    type: inferLiteral(types.LIFECYCLE_CONNECTION_ACTIVE),
    connection,
})
export const setLifecycleConnectionConfirmDelete = (connection: LifecycleConnection) => ({
    type: inferLiteral(types.LIFECYCLE_CONNECTION_CONFIRM_DELETE),
    connection,
})
export const setLifecycleConnectionReloadActive = (value: boolean) => ({
    type: inferLiteral(types.LIFECYCLE_CONNECTION_RELOAD_ACTIVE),
    value,
})


export const setLifecycleModelDragPhase = (dragPhase: Konva.Node) => ({
    type: inferLiteral(types.LIFECYCLE_MODEL_DRAG_PHASE),
    dragPhase,
})
export const setLifecycleModelDrawConnection = (drawConnection: LifecycleConnection) => ({
    type: inferLiteral(types.LIFECYCLE_MODEL_DRAW_CONNECTION),
    drawConnection,
})
export const setLifecycleModelLoadState = (value: StateType) => ({
    type: inferLiteral(types.LIFECYCLE_MODEL_LOAD_STATE),
    value,
})
export const setLifecycleModelReload = (value: boolean) => ({
    type: inferLiteral(types.LIFECYCLE_MODEL_RELOAD),
    value,
})


// import from library

export const setLifecycleImportFromLibraryList = (lifecycleList: types.LifecycleList) => ({
    type: inferLiteral(types.LIFECYCLE_IMPORT_FROM_LIBRARY_LIST),
    lifecycleList,
})
export const setLifecycleImportFromLibraryIds = (lifecycleIds: readonly number[]) => ({
    type: inferLiteral(types.LIFECYCLE_IMPORT_FROM_LIBRARY_IDS),
    lifecycleIds,
})
export const setLifecycleImportFromLibrarySort = (sortColumn: keyof Lifecycle, sortOrder: OrderType) => ({
    type: inferLiteral(types.LIFECYCLE_IMPORT_FROM_LIBRARY_SORT),
    sortColumn,
    sortOrder,
})
export const setLifecycleImportFromLibraryFilters = (filters: types.LifecycleImportFilters) => ({
    type: inferLiteral(types.LIFECYCLE_IMPORT_FROM_LIBRARY_FILTERS),
    filters,
})


// import from account
export const setLifecycleImportFromAccountList = (lifecycleList: types.LifecycleList) => ({
    type: inferLiteral(types.LIFECYCLE_IMPORT_FROM_ACCOUNT_LIST),
    lifecycleList,
})
export const setLifecycleImportFromAccountIds = (lifecycleIds: readonly number[]) => ({
    type: inferLiteral(types.LIFECYCLE_IMPORT_FROM_ACCOUNT_IDS),
    lifecycleIds,
})
export const setLifecycleImportFromAccountSort = (sortColumn: keyof Lifecycle, sortOrder: OrderType) => ({
    type: inferLiteral(types.LIFECYCLE_IMPORT_FROM_ACCOUNT_SORT),
    sortColumn,
    sortOrder,
})
export const setLifecycleImportFromAccountFilters = (filters: types.LifecycleImportFilters) => ({
    type: inferLiteral(types.LIFECYCLE_IMPORT_FROM_ACCOUNT_FILTERS),
    filters,
})


export const setLifecycleImportId = (lifecycleId: number) => ({
    type: inferLiteral(types.LIFECYCLE_IMPORT_ID),
    lifecycleId,
})
export const setLifecycleReloadImported = (value: boolean) => ({
    type: inferLiteral(types.LIFECYCLE_RELOAD_IMPORTED),
    value,
})
